import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService); // Inyecta el servicio
  const router = inject(Router); // Inyecta el enrutador

  if (authService.isAuthenticated()) {
    return true; // Permite el acceso si está autenticado
  } else {
    router.navigate(['auth/login'], { queryParams: state.url && state.url !== '/' ? { returnUrl: state.url } : {} }); // Redirige al login si no está autenticado
    return false; // Bloquea la ruta
  }
};


